<template>
    <v-dialog v-model="mostrar" persisten width="800px">
        <v-card v-if="tipoCaja == 'nueva'" :loading="loading">
            <v-toolbar color="blue-grey darken-2" dark>
                <v-toolbar-title>Agregar caja</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
                <v-container>
                    <v-col>
                        <v-text-field
                            v-model="numero"
                            label="Número"
                            dense
                            required
                            :rules="rules"

                            ></v-text-field>
                    </v-col>
                    <v-col>
                        <v-autocomplete label="Unidad admnistrativa" v-model="selectedDependencia" :items="dependencias" hide-details="auto" return-object item-text="nombre" autofocus></v-autocomplete>
                    </v-col>
                    <v-col>
                    <v-autocomplete label="Unidad generadora" v-model="genera" :items="dependencias" hide-details="auto" return-object item-text="nombre" autofocus></v-autocomplete>
                    </v-col>
                    <v-col>
                        <v-select 
                            v-model="tipo"
                            :items="['PAPEL','ELECTRONICO']"
                            label="Tipo de documentos"
                        />
                    </v-col>
                    <v-col>
                        <v-menu
                        v-model="fechaPicker"
                        :close-on-content-click="false"
                        max-width="290"
                        >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            :value="fechaInicioTexto"
                            label="Fecha Inicio:"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="fechaInicio"
                            locale="es"
                            @change="fechaPicker = false"
                            ></v-date-picker>
                         </v-menu>
                    </v-col>
                    <v-col>
                       <v-menu
                        v-model="fechaPicker2"
                        :close-on-content-click="false"
                        max-width="290"
                        >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            :value="fechaFinTexto"
                            label="Fecha Fin:"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="fechaFin"
                            locale="es"
                            @change="fechaPicker2 = false"
                            :min="fechaInicio"
                            ></v-date-picker>
                         </v-menu>
                    </v-col>
                    
                </v-container>
            </v-card-text>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="blue-grey darken-1" outlined text @click="$emit('cancelar')" :disabled="loading" :loading="loading">Cancelar</v-btn>
                <v-btn color="blue-grey darken-1" @click="agregarNuevaCaja()" dark :disabled="loading" :loading="loading">Agregar</v-btn>
            
            </v-card-actions>
        </v-card>
        <v-card v-if="tipoCaja == 'existente'" :loading="loading">
            <v-toolbar color="blue-grey darken-2" dark>
                <v-toolbar-title>Agregar a caja existente</v-toolbar-title>
                <v-spacer></v-spacer>
             <v-btn  outlined  text @click="$emit('cancelar')">Cancelar</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-container>
                    <span v-if="cajas.length==0">No hay cajas registradas aún</span>
                    <v-data-table
                    v-if="cajas.length"
                    :headers="headers"
                    :items="cajas"
                    :search="search"
                    locale="es-mx"
                    :footer-props="{
                    'items-per-page-all-text':'Todos',
                    'items-per-page-text':'Columnas'
                }"
                    >
                    <template v-slot:body="{ items }">
                            <tbody>
                            <tr v-for="item in items" :key="item.name">
                                
                                <td> {{item.numero}}
                                
                            
                                <td>{{fecha(item.fechaInicio)}}</td>
                                <td>{{fecha(item.fechaFin)}}</td>
                                <td>{{item.unidadAdministrativa.nombre}}</td>

                                <td>
                                <v-btn color="blue-grey darken-2" dark @click="addToBox(item._id)" :disabled="loading" :loading="loading">
                                    Agregar a esta caja
                                </v-btn>
                                </td>

                            </tr>
                            </tbody>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card-text>

           
        </v-card>
    </v-dialog>
       
</template>

<script>
import { getDependencias } from '../expedientes/expediente.service';
import {DateTime} from 'luxon'
import { guardarCajaService, addToBoxService, getCajasService} from './archivo.service'
export default {
    name:"agregarCaja",
    props:['mostrar', 'tipoCaja', 'expediente'],
    data: () => ({
        rules: [
            value => !!value || 'Campo requerido',
        ],
        loading: false,
        dependencias: [],
        selectedDependencia: null,
        fechaInicio: '',
        fechaPicker:false,
        fechaFin:'',
        fechaPicker2:false,
        tipo:'PAPEL',
        cajas:[],
        caja:'',
        headers: [
            { text: 'Clave', value: 'clave' },
            { text: 'Fecha de apertura', value: 'fechaApertura' },
            { text: 'Fecha de cierre', value: 'fechaCierre' },
            { text: 'Dependencia', value: 'unidadAdministrativa.nombre' },
            { text: '', value: 'options', sortable: false },
        ],
        search:'',
        genera:'',
        numero:''
    }),
    computed: {
        fechaInicioTexto() {
            return  this.fechaInicio ? DateTime.fromFormat(this.fechaInicio, 'yyyy-MM-dd').toFormat("dd 'de' MMMM 'de' yyyy")  : ''
        },
        fechaFinTexto() {
            return  this.fechaFin? DateTime.fromFormat(this.fechaFin, 'yyyy-MM-dd').toFormat("dd 'de' MMMM 'de' yyyy")  : ''
        },
        
        
    },
    async created() {
        try {
            if(this.tipoCaja=='nueva'){
                this.loading=true;
                const serverResponse = await getDependencias();
                this.loading=false;
                if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
                this.dependencias = serverResponse.dependencias
                this.selectedDependencia = this.dependencias[0];
                this.genera = this.dependencias[0];
            }
            else{ 
                this.loading=true;
                const serverResponse = await getCajasService();
                this.loading=false;
                if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
                this.cajas = serverResponse.cajas
            }
            
        } catch (error) {
            this.$notificarError(error);
        }
    },
    methods:{
        async agregarNuevaCaja(){
            try{
                const data = {
                    unidadAdministrativa:this.selectedDependencia._id,
                    tipoDocumental:this.tipo,
                    dependenciaGeneradora:this.genera._id,
                    fechaInicio:this.fechaInicio,
                    fechaFin:this.fechaFin,
                    numero:this.numero
                }
                this.loading=true;
                
                const serverResponse = await guardarCajaService(data, this.expediente)
                this.loading=false;
                if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
          
                this.$emit('cajaAgregada', serverResponse.caja)
                this.$emit('cancelar')

            }catch(error){
                this.$notificarError(error);
            }
        },
        async addToBox(caja){
             try{
      
                this.loading=true;
                const serverResponse = await addToBoxService(caja, this.expediente)
                this.loading=false;
                if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
                this.$emit('cajaAgregada', serverResponse.caja)
                this.$emit('cancelar')
                

            }catch(error){
                this.loading=false
                this.$notificarError(error);
            }

        },
        fecha(fecha){
            return DateTime.fromISO(fecha).toFormat('dd - MM - yyyy')
        }
        

    }
}


</script>